import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

window.initSmoothScroll = () => {
  const lenis = new Lenis({
    prevent: (node) => {
      if (node.id === 'interactive-map-modal') return true
      if (node.classList.contains('modal-generic__inner')) return true
      return false
    }
  })

  function raf(time: any) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  window.scrollToMapPoint = (
    scrollToTriggerEl: HTMLElement,
    onCompleteCallback: () => void = () => {},
    offset = 0,
  ) => {
    lenis.scrollTo(scrollToTriggerEl, {
      offset,
      onComplete: onCompleteCallback,
    })
  }

  window.pauseSmoothScroll = () => {
    lenis.stop()
  }

  window.resumeSmoothScroll = () => {
    lenis.start()
  }
}
